import { useEffect, useState } from 'react'

/**
 * Generic matchMedia hook. Returns true while `query` matches. SSR-safe:
 * returns `defaultValue` when there's no window.
 *
 * Used by AdSlot to mount AdSense units only when their breakpoint is active -
 * AdSense throws "No slot size for availableWidth=0" on a zero-width <ins>, so
 * a slot must be conditionally rendered, not merely CSS-hidden.
 */
export default function useMediaQuery(query, defaultValue = false) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return defaultValue
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined
    const mql = window.matchMedia(query)
    const handler = (e) => setMatches(e.matches)
    mql.addEventListener('change', handler)
    setMatches(mql.matches)
    return () => mql.removeEventListener('change', handler)
  }, [query])

  return matches
}
